import '../../../../packages/neb-lit-components/src/components/neb-text';
import '../../misc/neb-icon';

import { openPopup } from '@neb/popup';
import { css, html } from 'lit';

import NebTable, {
  ELEMENTS as BASE_ELEMENTS,
} from '../../../../packages/neb-lit-components/src/components/tables/neb-table';
import {
  RECOUP,
  REMOVE_RECOUP_HISTORY,
} from '../../../../packages/neb-lit-components/src/components/tables/neb-table-allocation-charges-2';
import { POPUP_RENDER_KEYS } from '../../../../packages/neb-popup/src/renderer-keys';
import { CSS_COLOR_HIGHLIGHT } from '../../../../packages/neb-styles/neb-variables';

export const ELEMENTS = {
  ...BASE_ELEMENTS,
  paymentNumberLinks: { selector: '[id^=payment-id-]' },
  recoupButtons: { selector: '[id^=recoup-button-]' },
  recoupedIndicators: { selector: '[id^=recouped-indicator-]' },
  removeRecoupIndicators: { selector: '[id^=remove-recoup-indicator-]' },
};

class NebTableOtherPayments extends NebTable {
  static get styles() {
    return [
      super.styles,
      css`
        .recouped-icon {
          width: 16px;
          height: 16px;
          stroke-width: 1;
          fill: ${CSS_COLOR_HIGHLIGHT};
          margin-left: 2px;
          align-self: center;
        }

        .recoup-icon,
        .remove-recoup-icon {
          width: 16px;
          height: 16px;
          stroke-width: 1;
          fill: ${CSS_COLOR_HIGHLIGHT};
          margin-left: 2px;
          align-self: center;
          cursor: pointer;
        }
      `,
    ];
  }

  initState() {
    super.initState();

    this.onPaymentLinkClick = () => {};

    this.onRecoup = () => {};

    this.onRemoveRecoupHistory = () => {};
  }

  initHandlers() {
    super.initHandlers();

    this.handlers = {
      ...this.handlers,
      clickPaymentLink: e => {
        const rowIndex = e.currentTarget.getAttribute('rowIndex');

        this.onPaymentLinkClick(rowIndex);
      },
      recoup: async ({ allocationId, paymentId, rowIndex }) => {
        const accepted = await openPopup(POPUP_RENDER_KEYS.CONFIRM, RECOUP);

        if (accepted) {
          this.onRecoup({ allocationId, paymentId, rowIndex });
        }
      },
      removeRecoupHistory: async ({
        paymentId,
        allocationId,
        recoupId,
        rowIndex,
      }) => {
        const accepted = await openPopup(
          POPUP_RENDER_KEYS.CONFIRM,
          REMOVE_RECOUP_HISTORY,
        );

        if (accepted) {
          this.onRemoveRecoupHistory({
            allocationId,
            paymentId,
            recoupId,
            rowIndex,
          });
        }
      },
    };
  }

  __renderRecoupedIndicator({ paymentId, allocationId, recoupId, rowIndex }) {
    return html`
      <neb-icon
        id="recouped-indicator-${rowIndex}"
        class="recouped-icon"
        icon="neb:swapVerticalCircle"
        title="Reversed"
      ></neb-icon>
      <neb-icon
        id="remove-recoup-indicator-${rowIndex}"
        class="remove-recoup-icon"
        icon="neb:close"
        title="Remove Reversal History"
        @click="${() =>
          this.handlers.removeRecoupHistory({
            paymentId,
            allocationId,
            recoupId,
            rowIndex,
          })}"
      ></neb-icon>
    `;
  }

  __renderRecoupButton({ paymentId, allocationId, rowIndex }) {
    return html`
      <neb-icon
        @click="${() =>
          this.handlers.recoup({ paymentId, allocationId, rowIndex })}"
        id="recoup-button-${rowIndex}"
        class="recoup-icon"
        icon="neb:undo"
        title="Reverse"
      ></neb-icon>
    `;
  }

  renderDataCell(value, columnConfig, rowIndex) {
    const { key } = columnConfig;

    switch (key) {
      case 'paymentNumber':
        return html`
          <neb-text
            bold
            link
            id="payment-id-${rowIndex}"
            rowIndex="${rowIndex}"
            @click="${this.handlers.clickPaymentLink}"
            >${value}
          </neb-text>
        `;

      case 'allocationAmount':
        return html`
          <neb-text>${value} </neb-text>

          ${this.model[rowIndex].recoupId
            ? html`
                ${this.__renderRecoupedIndicator({
                  paymentId: this.model[rowIndex].id,
                  allocationId: this.model[rowIndex].allocationId,
                  recoupId: this.model[rowIndex].recoupId,
                  rowIndex,
                })}
              `
            : html` ${this.__renderRecoupButton({
                paymentId: this.model[rowIndex].id,
                allocationId: this.model[rowIndex].allocationId,
                rowIndex,
              })}`}
        `;
      default:
        return super.renderDataCell(value, columnConfig, rowIndex);
    }
  }
}

customElements.define('neb-table-other-payments', NebTableOtherPayments);
